import core from '@/helpers/client'

const approvalService = {
  async headApprovalMasterAsync(params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/ApprovalDocuments`,
      params
    )
    return result
  },
  async getApprovalMasterListAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/ApprovalDocuments`,
      params
    )
    return result
  },
  async getApprovalMasterDetailAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/ApprovalDocuments/${id}`
    )
    return result
  },
  async getApprovalDataPayloadAsync(id, data_id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/ApprovalDocuments/${id}/datas/${data_id}`
    )
    return result
  },
  async getApprovalDataPayloadRemarkAsync(id, data_id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/ApprovalDocuments/${id}/datas/${data_id}/remark`
    )
    return result
  },
  async getApprovalDataPayloadLastVersionAsync(id, data_id, rule_id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/ApprovalDocuments/${id}/datas/${data_id}/${rule_id}/2lastversion`
    )
    return result
  },
  async createApprovalMasterAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/ApprovalDocuments`,
      model
    )
    return result
  },
  async updateApprovalApproveStatusAsync(id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/ApprovalDocuments/${id}/Status`,
      model
    )
    return result
  },
  async approveApprovalStatusWithDataAsync(id, data_id, rule_id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/ApprovalDocuments/${id}/Status/Approve/Datas/${data_id}/${rule_id}`,
      model
    )
    return result
  },
  async updateApprovalDataPayloadAsync(id, data_id, rule_id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/ApprovalDocuments/${id}/datas/${data_id}/${rule_id}`,
      model
    )
    return result
  },
  async refreshApproverProcessOfApprovalDocumentAsync(id, process_id) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/ApprovalDocuments/${id}/processes/${process_id}`,
      {}
    )
    return result
  },
  async deleteApprovalUserByIdAsync(id, openId) {
    const result = await core.delete(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/ApprovalDocuments/${id}/users/${openId}`
    )
    return result
  },
}
export default approvalService
